// SVG path builder for the editable path/polygon element. Straight segments
// (polyline/polygon) or a smooth curve through the SAME vertices via a
// Catmull-Rom → cubic-bézier conversion (so vertex editing is unchanged).
// Mirrored in the View SDK (mcp-gateway/designer/view-html.ts).
export interface Vec { x: number; y: number }

const r1 = (n: number) => Math.round(n * 10) / 10;

export function buildPathD(pts: Vec[], closed: boolean, smooth: boolean): string {
  if (!pts.length) return '';
  if (pts.length === 1) return `M${pts[0]!.x},${pts[0]!.y}`;
  if (!smooth) {
    let d = `M${pts[0]!.x},${pts[0]!.y}` + pts.slice(1).map((p) => `L${p.x},${p.y}`).join('');
    if (closed) d += 'Z';
    return d;
  }
  const n = pts.length;
  const get = (i: number): Vec => (closed ? pts[((i % n) + n) % n]! : pts[Math.max(0, Math.min(n - 1, i))]!);
  let d = `M${pts[0]!.x},${pts[0]!.y}`;
  const segs = closed ? n : n - 1;
  for (let i = 0; i < segs; i++) {
    const p0 = get(i - 1), p1 = get(i), p2 = get(i + 1), p3 = get(i + 2);
    const c1x = p1.x + (p2.x - p0.x) / 6, c1y = p1.y + (p2.y - p0.y) / 6;
    const c2x = p2.x - (p3.x - p1.x) / 6, c2y = p2.y - (p3.y - p1.y) / 6;
    d += `C${r1(c1x)},${r1(c1y)} ${r1(c2x)},${r1(c2y)} ${r1(p2.x)},${r1(p2.y)}`;
  }
  if (closed) d += 'Z';
  return d;
}
